import { integrationService } from '@/services'
import { createMutationMixin } from '@/shared'
import { removeTypename, useQuery } from 'codefabrik-gui-vue/src/apollo'

export const useCreateIntegration = (methodName) => createMutationMixin({
  name: methodName,
  service: [integrationService.createIntegration, 'integrations.saveSuccess'],
  onSuccess: navigateToManagePage
})

export function useIntegrations (name) {
  return {
    mixins: [
      useQuery({
        name: name,
        serviceFn: integrationService.getIntegrations,
        mappingFunctions: {
          integrations: [(integrationPage) => integrationPage.integration, () => []]
        }
      })
    ]
  }
}

export function useIntegrationGames (name, integrationId) {
  return {
    mixins: [
      useQuery({
        name: name,
        skipIf () {
          return this[integrationId] === '' || this[integrationId] === null
        },
        serviceFn: integrationService.getGames,
        variables () {
          return { input: { integrationId: this[integrationId] }}
        },
        mappingFunctions: {
          [name]: [(integrationGame) => integrationGame.sort((a, b) => a.game.name.localeCompare(b.game.name)).map(it => {
            return { id: it.id, active: it.active, name: it.game.name, version: it.gameVersion.version, gameVersionId: it.gameVersion.id }
          }), () => []]
        }
      })
    ]
  }
}


export function useAddableGames (name) {
  return {
    mixins: [
      useQuery({
        name: name,
        skipIf () {
          return this.integrationId === '' || this.integrationId === null
        },
        serviceFn: integrationService.getGameVersionsByGame,
        variables () {
          return { input: { limit: 0, offset: 0, excludedIntegrationId: this.integrationId, gameFilter: this.filter }}
        },
        mappingFunctions: {
          [name]: [(gameVersionPage) => gameVersionPage.gameVersionsByGame.flatMap(it => {
            return it.gameVersions.map((version, index) => {
              return {
                id: it.game.id,
                name: index === 0 ? it.game.name : '',
                version: version.version,
                versionId: version.id
              }
            })
          }), () => []]
        }
      })
    ]
  }
}

export function useIntegration (name, idParam = "id") {
  return {
    mixins: [
      useQuery({
        name: name,
        serviceFn: integrationService.getIntegration,
        variables () {
          return { input: { integrationId: this.$route.params[idParam] }}
        },
        mappingFunctions: {
          [name]: [(integration) => removeTypename(integration), () => ({})]
        }
      })
    ]
  }
}

export const useIntegrationGame = (name) => ({
  mixins: [
    useQuery({
      name: name,
      serviceFn: integrationService.getIntegrationGame,
      variables () {
        return {
          input: {
            id: this.$route.params.integrationGameId
          }
        }
      }
    })
  ]
})

export const useDeactivateIntegrationGame = (methodName) => createMutationMixin({
  name: methodName,
  service: [integrationService.deactivateIntegrationGame, 'integrations.gameDeactivated'],
  mapInput (input) {
    return { id: this.$route.params.integrationGameId, ...input }
  }
})

export const useActivateIntegrationGame = (methodName) => createMutationMixin({
  name: methodName,
  service: [integrationService.activateIntegrationGame, 'integrations.gameActivated'],
  mapInput (input) {
    return { id: this.$route.params.integrationGameId, ...input }
  }
})

export const useAddGameToIntegration = (methodName) => createMutationMixin({
  name: methodName,
  service: [integrationService.createIntegrationGame, 'integrations.gameAdded'],
})

export const useRemoveGameFromIntegration = (methodName) => createMutationMixin({
  name: methodName,
  service: [integrationService.deleteIntegrationGame, 'integrations.gameRemoved'],
})

export const useEditIntegration = (methodName) => createMutationMixin({
  name: methodName,
  service: [integrationService.editIntegration, 'integrations.saveSuccess'],
  mapInput (input) {
    return { id: this.$route.params.id, ...input }
  },
  onSuccess: navigateToManagePage
})

export const useDeleteIntegration = (methodName) => createMutationMixin({
  name: methodName,
  service: [integrationService.deleteIntegration, 'integrations.deleteSuccess'],
  mapInput () {
    return { id: this.$route.params.id }
  },
  onSuccess: navigateToManagePage
})


function navigateToManagePage () {
  this.$router.push({ name: 'manage-integrations' })
}
